export enum EServiceMessageActionTypes {
  SET_NEW_YEAR_SHOWN = 'serviceMessage/isNewYearAlertShown',
  SET_NEW_YEAR_SHOULD_SHOWN = 'serviceMessage/isNewYearAlertShouldShown',
}
